var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7064 2.20989L13.1051 4.6086C13.2062 4.70965 13.2062 4.87453 13.1051 4.97558L7.29717 10.7835L4.82932 11.0574C4.49956 11.0947 4.22034 10.8154 4.25757 10.4857L4.53148 8.01784L10.3394 2.20989C10.4405 2.10884 10.6054 2.10884 10.7064 2.20989ZM15.0145 1.60091L13.7168 0.303162C13.3125 -0.101054 12.6557 -0.101054 12.2488 0.303162L11.3074 1.24456C11.2064 1.34561 11.2064 1.51049 11.3074 1.61155L13.7061 4.01025C13.8072 4.1113 13.9721 4.1113 14.0731 4.01025L15.0145 3.06885C15.4187 2.66198 15.4187 2.00513 15.0145 1.60091ZM10.2118 9.2039V11.9111H1.70196V3.40127H7.81307C7.89817 3.40127 7.97795 3.3667 8.03911 3.30819L9.10284 2.24446C9.30495 2.04236 9.16135 1.6993 8.8768 1.6993H1.27647C0.571753 1.6993 0 2.27106 0 2.97578V12.3366C0 13.0413 0.571753 13.613 1.27647 13.613H10.6373C11.342 13.613 11.9137 13.0413 11.9137 12.3366V8.14017C11.9137 7.85562 11.5707 7.71468 11.3686 7.91413L10.3049 8.97786C10.2463 9.03902 10.2118 9.1188 10.2118 9.2039Z",
    fill: "#2FC18C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bcdcb7233e354bc7f7caff6cb1c1a199.svg";
export { ForwardRef as ReactComponent };